import * as React from 'react'
import Checkbox from '@mui/material/Checkbox'
import IconButton from '@mui/material/IconButton'
import DragIndicator from '@mui/icons-material/DragIndicator'
import Close from '@mui/icons-material/Close'

import {
  Option,
  OptionRow,
  OptionName,
  OptionError,
  OptionCheckbox,
} from './atoms'
import { useOptionActions } from './hooks'

export type DropdownOptionProps = {
  index: number
  onRemove: (index: number) => void
}

export function DropdownOption(props: DropdownOptionProps) {
  const {
    optionError,
    onChangeName,
    onClickRemove,
    onChangeActive,
    option: { name, active },
  } = useOptionActions(props)

  return (
    <Option>
      <OptionRow>
        <DragIndicator sx={{ cursor: 'grab' }} />

        <OptionName
          required
          fullWidth
          value={name}
          label="Option"
          margin="dense"
          error={!!optionError}
          onChange={onChangeName}
        />

        <IconButton
          size="small"
          onClick={onClickRemove}
          data-test-id={`customFieldOptionRemoveBtn-${props.index}`}
        >
          <Close fontSize="small" />
        </IconButton>
      </OptionRow>

      {!!optionError && <OptionError error>{optionError}</OptionError>}

      <OptionCheckbox
        label="This value will be active"
        control={<Checkbox checked={active} onChange={onChangeActive} />}
      />
    </Option>
  )
}
